var escape = require("../../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top[data-v-3ede4c9c]{margin-bottom:12px;font-family:Open Sans,sans-serif;-ms-transform:translateY(-9px);transform:translateY(-9px)}.top__link[data-v-3ede4c9c]{margin-bottom:6px;width:127px;height:13px;font-size:10px;font-weight:600;color:#8163a6;text-decoration:none;text-transform:uppercase;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.top__link[data-v-3ede4c9c]:before{content:\"\";display:inline-block;width:29px;height:13px;background:url(" + escape(require("./images/back.svg")) + ") no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ede4c9c","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/modules/remote-edu/components/top/Top.vue
// module id = 659d480ed4e25e4db039
// module chunks = 0